(function () {
  var OVERLAY_ID = 'bw-line-overlay';
  var MINIBAR_ID = 'bw-line-minibar';
  var STORAGE_KEY = 'bwLinePopupLastShownAt';
  var COOLDOWN_DAYS = 7;

  function now(){ return Date.now(); }

  function shouldAutoShow(){
    try{
      var last = localStorage.getItem(STORAGE_KEY);
      if(!last) return true;
      return (now() - Number(last)) > (COOLDOWN_DAYS * 24 * 60 * 60 * 1000);
    }catch(e){ return true; }
  }

  function markShown(){
    try{ localStorage.setItem(STORAGE_KEY, String(now())); }catch(e){}
  }

  function openModal(){
    var overlay = document.getElementById(OVERLAY_ID);
    var minibar = document.getElementById(MINIBAR_ID);
    if(!overlay || !minibar) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    minibar.classList.remove('is-visible');
  }

  function closeModalKeepMinibar(){
    var overlay = document.getElementById(OVERLAY_ID);
    var minibar = document.getElementById(MINIBAR_ID);
    if(!overlay || !minibar) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    minibar.classList.add('is-visible');
  }

  document.addEventListener('DOMContentLoaded', function(){
    var overlay = document.getElementById(OVERLAY_ID);
    var minibar = document.getElementById(MINIBAR_ID);
    if(!overlay || !minibar) return;

    var closeBtn = overlay.querySelector('.bw-line-close');
    if(closeBtn) closeBtn.addEventListener('click', closeModalKeepMinibar);

    overlay.addEventListener('click', function(e){
      if(e.target === overlay) closeModalKeepMinibar();
    });

    minibar.addEventListener('click', openModal);

    if(shouldAutoShow()){
      markShown();
      openModal();
    }else{
      closeModalKeepMinibar(); // 自動表示しない期間でもミニバーは出す
    }

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModalKeepMinibar();
      }
    });
  });
})();